import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { CONDITIONS_PENDING, CONDITIONS_SUCCESS, CONDITIONS_ERROR } from '../types';

export const getConditions = () => async (dispatch, getState) => {
  const conditionsStatus = getState().conditions.status;
  dispatch({
    type: CONDITIONS_PENDING,
    payload: [],
  });
  // If more than one component calls the same feed make sure we only make one request
  if (conditionsStatus === FetchStatus.IDLE) {
    try {
      const res = await axios.get(`${getNodeApiDomain()}/dor/conditions`);
      dispatch({
        type: CONDITIONS_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: CONDITIONS_ERROR,
        payload: error,
      });
    }
  }
};
